import { Box, Heading } from '@99designs/emu';
import {
    FAQFormattedAnswer,
    FlexibleColumnFAQs,
    GridLayout,
    QuestionAnswerProps,
} from '@99designs/marketing-ui';
import { TabId } from '../TabsMenu';
import type { QuestionAndAnswer } from '../../types';

interface Props {
    faqs: {
        title: string;
        body: QuestionAndAnswer[];
    };
}

const formatFaqs = (faqs: QuestionAndAnswer[]): QuestionAnswerProps[] => {
    return faqs.map(({ question, answer, links }, i) => ({
        id: `faq${i}`,
        question,
        answer: getFormattedAnswer(answer, links),
    }));
};

const getFormattedAnswer = (answer: string, links?: Record<string, string>) => {
    return (
        <Box
            paddingBottom="1.5bu"
            maxWidth={['fit-content', 'fit-content', '720px', '720px']}
            as="p"
        >
            <FAQFormattedAnswer answer={answer} linksReplacements={links || {}} />
        </Box>
    );
};

export function FAQSection({ faqs }: Props) {
    return (
        <Box id={TabId.Faq}>
            <GridLayout>
                <Heading appearanceLevel={3} accessibilityLevel={2}>
                    {__('Frequently asked questions')}
                </Heading>
                <Box display="flex" paddingY="2bu" flexDirection="column">
                    <FlexibleColumnFAQs faqSections={[formatFaqs(faqs.body)]} />
                </Box>
            </GridLayout>
        </Box>
    );
}
